module.exports = __webpack_public_path__ + "static/media/ImageTwo.d68773e6.jpg";